<div class="container-info light animated fadeIn">
    <div class="head d-flex justify-content-between">
        <p>Tipo de documento</p>
        <p class="cr-pointer" (click)="close()">X</p>
     </div>
</div>

    <form [formGroup]="formDocument" class="ms-3">

        <p class="mt-3 cl-grey fs-24 m-0 mt-1 mb-3 cl-primary text-center"><strong>Selecciona tu tipo de Identificacion:</strong></p>

        <mat-radio-group formControlName="isINE" (change)="changeDocumentType()" class="text-center d-block m-auto">
            <mat-radio-button [value]="optionsRadio[0]" class="fs-14" optionsDocumentType>INE</mat-radio-button>
            <mat-radio-button [value]="optionsRadio[1]" class="fs-14 ms-4">Otro</mat-radio-button>
        </mat-radio-group>

        <div *ngIf="ineShow === true else noUploadINE">
            <div class="d-block m-auto d-md-flex align-items-center justify-content-md-evenly animated fadeIn mt-md-4">
               <!-- Contenedor para subir INE Frontal -->
               <div class="d-block m-auto my-4 my-md-0 col-12 col-sm-10 col-md-5">
                  <file-pond #pondIdCardFront [options]="idCardFrontOptions" [files]="idCardFrontFiles" (onaddfile)="pondHandleAddFile($event, 'idCardFront')"
                     (onremovefile)="deleteFile('idCardFront')" *ngIf="!idCardFrontFile" [ngStyle]="{'width': idCardFrontDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="idCardFrontDefined" class="cr-pointer cl-primary my-auto" (click)="idCardFrontFile = idCardFrontDefined; idCardFrontDefined = undefined"></fa-icon>
               </div>
               <!-- End contenedor para subir INE Frontal -->

               <!-- Contenedor para subir INE Reves -->
               <div class="d-block m-auto my-4 my-md-0 col-12 col-sm-10 col-md-5">
                  <file-pond #pondIdCardBack [options]="idCardBackOptions" [files]="idCardBackFiles" (onaddfile)="pondHandleAddFile($event, 'idCardBack')"
                  (onremovefile)="deleteFile('idCardBack')" *ngIf="!idCardBackFile" [ngStyle]="{'width': idCardBackDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="idCardBackDefined" class="cr-pointer cl-primary my-auto" (click)="idCardBackFile = idCardBackDefined; idCardBackDefined = undefined"></fa-icon>
               </div>
               <!-- End contenedor para subir INE Reves -->               
            </div>
         </div>
         

         <ng-template #noUploadINE>

            <!-- Tipo de documento en caso de ser otros -->
            <div class="mt-5 col-12 animated fadeIn" *ngIf="ineShow !== null && ineShow == false">
               <p class="cl-grey fs-13 m-0 mb-3 text-center"><strong>Selecciona el documento que corresponda a <br>la identificación que vas a cargar.</strong></p>
               <div class="col-11 col-md-8 d-block m-auto">
                  <mat-form-field appearance="outline" class="mnf-select">
                     <mat-select formControlName="typeDocument">
                        <mat-option [value]="s" *ngFor="let s of optionsDocument" [title]="s">
                           {{ s }}
                        </mat-option>
                     </mat-select>
                  </mat-form-field>
               </div>
            </div>
            <!-- End tipo de documento en caso de ser otros -->

            <div class="animated fadeIn mb-3" *ngIf="ineShow !== null">
               <!-- Contenedor para subir Otros documentos -->
               <div class="col-12 col-sm-10 col-md-9 d-block mt-4 m-auto">
                  <file-pond #pondOther [options]="otherOptions" [files]="otherFiles" (onaddfile)="pondHandleAddFile($event, 'otherDocument')"
                  (onremovefile)="deleteFile('otherDocument')" *ngIf="!otherFile" [ngStyle]="{'width': otherDefined ? '90%' : '100%' }">
                  </file-pond>
                  <fa-icon [icon]="iconX" *ngIf="otherDefined" class="cr-pointer cl-primary my-auto" (click)="otherFile = otherDefined; otherDefined = undefined"></fa-icon>
               </div>
               <!-- End contenedor para subir Otros documentos -->
            </div>

         </ng-template>

    </form>

    <div class="d-flex flex-column justify-content-center align-items-center mt-5 mb-1 animated fadeIn pb-4">
        <button mat-button [disabled]="validateDocument()" (click)="uploadDoc()">Subir documentos</button>
     </div>